import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import ShopNavbar from '../components/ShopNavbar';
import ShopFooter from '../components/ShopFooter';
import { SEGMENTS, THEMES, TYPES, PALETTE } from '../lib/catalog';
import { INR } from '../lib/shop';
import '../styles/shop.css';

const IMG = (h) => `https://static.prod-images.emergentagent.com/jobs/ef0791b4-8335-4a62-aebb-5ef8cf8b3a33/images/${h}.jpeg`;
const TYPE_IMG = {
  tee: IMG('96c24bdb3e629c4063cf78a5f017323b2a98200ee9ec474a17bf41133b5eda94'),
  kurta: IMG('7473e75f6c9e3e73b021f03df99fe4a864dc39516488952c4fa3affcf5ec15f5'),
  punjabi: IMG('b6034c591f5e3120a897933a0475fd6f6c81a2b1560af38801eabb57528d58ad'),
  saree: IMG('55819f618a5b2f2690522bbe4f70af4ee1f90cc76c384c6d1770fcd8a49f0cf0'),
  kurti: IMG('70752e560a018d27229a01034a62c5ac6c920c1e66c4fb80cc632e21b73ab827'),
};

const Block = ({ title, children, testid }) => (
  <section className="si-card p-4 md:p-6" data-testid={testid}>
    <h2 className="text-base md:text-lg font-bold mb-4">{title}</h2>
    {children}
  </section>
);

const Categories = () => (
  <div className="si-page">
    <ShopNavbar />
    <main className="max-w-7xl mx-auto px-3 md:px-6 py-4 md:py-6 space-y-4">
      <Block title="Shop by type" testid="categories-types">
        <div className="grid grid-cols-3 md:grid-cols-5 gap-3">
          {TYPES.map(([k, l]) => (
            <Link key={k} to={`/shop?type=${k}`} className="group text-center" data-testid={`cat-type-${k}`}>
              <div className="aspect-square rounded-full overflow-hidden bg-[var(--si-bg-soft)] ring-2 ring-transparent group-hover:ring-[var(--si-yellow)] transition-shadow">
                <img src={TYPE_IMG[k]} alt={l} className="w-full h-full object-cover object-top" loading="lazy" />
              </div>
              <p className="mt-2 text-sm font-semibold group-hover:text-[var(--si-blue)]">{l}</p>
            </Link>
          ))}
        </div>
      </Block>
      <Block title="Shop by price" testid="categories-prices">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-2 md:gap-3">
          {SEGMENTS.map((s, i) => (
            <Link key={s.price} to={`/shop?segment=${s.price}`} data-testid={`cat-price-${s.price}`}
              className="rounded-md p-4 border border-black/5 hover:shadow-md transition-shadow" style={{ background: PALETTE[i % PALETTE.length].bg }}>
              <p className="text-2xl font-extrabold" style={{ color: PALETTE[i % PALETTE.length].fg }}>{INR(s.price)}</p>
              <p className="text-sm text-[var(--si-black)] mt-1 line-clamp-2">{s.sub}</p>
            </Link>
          ))}
        </div>
      </Block>
      <Block title="Story collections" testid="categories-themes">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
          {Object.entries(THEMES).map(([k, t]) => (
            <Link key={k} to={`/shop?theme=${k}`} data-testid={`cat-theme-${k}`}
              className="rounded-md p-5 text-white flex items-center justify-between gap-3 hover:brightness-110 transition" style={{ background: t.bg }}>
              <div><p className="text-xs font-bold uppercase tracking-wider text-[var(--si-yellow)]">{t.tag}</p><p className="text-lg font-bold leading-tight mt-1">{t.title}</p></div>
              <ChevronRight className="w-6 h-6 shrink-0" />
            </Link>
          ))}
        </div>
      </Block>
      <Block title="Shop for" testid="categories-gender">
        <div className="grid grid-cols-3 gap-3">
          {[['men', 'Men'], ['women', 'Women'], ['unisex', 'Unisex']].map(([k, l]) => (
            <Link key={k} to={`/shop/${k}`} className="si-btn si-btn-outline !py-4 text-base" data-testid={`cat-gender-${k}`}>{l}</Link>
          ))}
        </div>
      </Block>
    </main>
    <ShopFooter />
  </div>
);

export default Categories;
